export default __webpack_public_path__ + "static/media/Group1464101.c58789ad.svg";